export default "__VITE_ASSET__CIU34BM4__"